import { render, staticRenderFns } from "./HomeTop.vue?vue&type=template&id=671e2d65&"
import script from "./HomeTop.vue?vue&type=script&lang=js&"
export * from "./HomeTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports